import axios from "axios";
import download from "downloadjs";

import { SERVER_URL } from "../app/ServerConfig";
import { logger } from "../app/utils/Debug";
import { NETWORK_ERROR } from "../app/utils/const";
const timeout = 60 * 1 * 1000; // Let's say you want to wait at least 1 mins
export const getCall = (url) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    axios
      .get(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        },
        credentials: "include",
        timeout,
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => {
        logger("API URL - ", baseUrl);
        logger("API Response - ", json);
        return resolve(json);
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const getPDFCall = (url, customPdfName) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    axios
      .get(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        },
        credentials: "include",
        responseType: "blob",
        timeout,
      })
      .then((res) => {
        const content = res.headers["content-type"];
        download(res.data, customPdfName + ".pdf", content);
        logger("API URL - ", baseUrl);
        logger("API Response - ", content);
        resolve({ content });
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const getPDFPrintCall = (url) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    axios
      .get(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        },
        credentials: "include",
        responseType: "blob",
        timeout,
      })
      .then((res) => {
        resolve({ res });
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const postCall = (url, data = {}) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    axios
      .post(baseUrl, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        },
        credentials: "include",
        timeout,
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => {
        logger("API URL - ", baseUrl);
        logger("API Response - ", json);
        return resolve(json);
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const patchCall = (url, data = {}) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    axios
      .patch(baseUrl, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        },
        credentials: "include",
        timeout,
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => {
        logger("API URL - ", baseUrl);
        logger("API Response - ", json);
        return resolve(json);
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const deleteCall = (url, data = {}) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    axios
      .delete(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        },
        credentials: "include",
        timeout,
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => {
        logger("API URL - ", baseUrl);
        logger("API Response - ", json);
        return resolve(json);
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const postCallWithMedia = (url, data = {}) =>
  new Promise((resolve) => {
    const baseUrl = `${SERVER_URL}${url}`;
    const formData = new FormData();
    formData.append("profile", data.file);

    axios({
      method: "POST",
      url: baseUrl,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
      },
      timeout,
    })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => {
        logger("API URL - ", baseUrl);
        logger("API Response - ", json);
        return resolve(json);
      })
      .catch((error) => {
        if (error && !error.response) {
          const errorObj = {
            Error: {
              message: NETWORK_ERROR,
            },
          };
          resolve(errorObj);
        }
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });
